import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_136: FaireProductEntity = {
  token: "legacy_prod_abbott-136",
  type: "product",
  name: "Brocade Print Umbrella Stand-Yellow & Blue-18 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b0da2a719f80ca7d950f4b1c2d0e4f1d8327e4c74c13eb96405fcde1426ea27f.jpeg",
  priceDollars: 48,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
